import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18eccdcb")

_pushScopeId("data-v-18eccdcb")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" お客様情報登録 ")
const _hoisted_2 = { class: "qrcode-frame" }
const _hoisted_3 = { class: "left-frame" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "qrcode-text" }, "お手持ちのスマートフォンでお客様のお名前、ご連絡先等を登録していただけます。"),
  /*#__PURE__*/_createVNode("div", { class: "qrcode-text" }, "こちらのコードを読み取ってください。")
], -1)
const _hoisted_5 = { class: "inline-text" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("またはアドレスをコピー ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" コード更新 ")
const _hoisted_8 = { class: "right-frame" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, "※約30分間有効です。", -1)
const _hoisted_10 = {
  key: 2,
  class: "loading"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("コード読み込み中")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_page_description = _resolveComponent("page-description")
  const _component_clipboard_copy_button = _resolveComponent("clipboard-copy-button")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_qrcode = _resolveComponent("qrcode")
  const _component_qrcode_error = _resolveComponent("qrcode-error")
  const _component_loading_message = _resolveComponent("loading-message")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_page_description),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_clipboard_copy_button, { text: _ctx.patientUrl }, null, 8, ["text"])
              ]),
              _createVNode(_component_normal_button, {
                class: "refresh-button",
                state: "normal",
                onClick: _ctx.forceRefresh
              }, {
                default: _withId(() => [
                  _createVNode(_component_fa_icon, { icon: "sync-alt" }),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_8, [
              (_ctx.fetchStatus === _ctx.FetchStatus.Fetched)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_qrcode, { url: _ctx.patientUrl }, null, 8, ["url"]),
                    _hoisted_9
                  ], 64))
                : (_ctx.fetchStatus === _ctx.FetchStatus.Failed)
                  ? (_openBlock(), _createBlock(_component_qrcode_error, { key: 1 }))
                  : (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode(_component_loading_message, null, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})